var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"size":"sm","disabled":_vm.isDownloading},on:{"click":function($event){return _vm.downloadFile()}}},[(_vm.isDownloading)?_c('div',[_vm._v("\n       Downloading...   "),_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"1x","pulse":""}})],1):_c('div',[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }